export default "__VITE_ASSET__DjVfT9xj__"